import classNames from 'classnames';
import { connectBidAsk } from 'components/secondaryMarket/shared/SidePanel/BidAsk.connect';
import { FormattedNumber } from 'react-intl';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import styled from 'styled-components';

interface SidePriceProps {
  value?: number;
  unit?: string;
}

function SidePrice({ value, unit }: SidePriceProps) {
  return (
    <span className="display-4 tabular-figures responsive-bidask-fs">
      {value === undefined ? null : (
        <>
          <FormattedNumber value={value} minimumFractionDigits={2} maximumFractionDigits={2} />
          {unit}
        </>
      )}
    </span>
  );
}

interface BidAskProps {
  bid?: number;
  ask?: number;
  tradeWay?: Nullable<TradeWay>;
  unit?: string;
  isLive: boolean;
}

const Bid = styled.div`
  border-top-left-radius: var(--bs-border-radius-lg) !important;
`;

const Ask = styled.div`
  border-top-right-radius: var(--bs-border-radius-lg) !important;
`;

function computeSideClass(side: 'bid' | 'ask', isActive: boolean, isLive: boolean) {
  if (isActive && isLive) {
    return `alert-discreet-${side}`;
  } else if (isLive) {
    return `text-${side}`;
  } else if (isActive) {
    return 'text-primary bg-primary bg-opacity-10';
  } else {
    return 'text-secondary';
  }
}

function BidAsk({ bid, ask, tradeWay, unit, isLive }: BidAskProps) {
  return (
    <div className="d-flex h-100 fw-semibold align-self-stretch">
      <Bid
        className={classNames(
          'col p-3 d-flex flex-column justify-content-between',
          computeSideClass('bid', tradeWay === 'ClientSell', isLive),
        )}
      >
        Bid
        <SidePrice value={bid} unit={unit} />
      </Bid>
      <Ask
        className={classNames(
          'border-start col p-3 d-flex flex-column justify-content-between',
          computeSideClass('ask', tradeWay === 'ClientBuy', isLive),
        )}
      >
        Ask
        <SidePrice value={ask} unit={unit} />
      </Ask>
    </div>
  );
}

export const ConnectedBidAsk = connectBidAsk(BidAsk);
